import React, {useState} from 'react';
import {Field} from 'formik';
import {
    FormControl,
    FormHelperText,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography
} from "@mui/material";
import {getRole, isAdmin, Role} from "../../../../utils/roles";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import Button from "@mui/material/Button";
import Constants from "../../../../utils/constants";
import Loader from "../../layout/loading/loader";
import Grid from "@mui/material/Grid2";


function UserDataField({...props}) {
    const {values, errors, exploitants, handleLogoChanged, mode, handleChange, handleBlur, villes, geoLoading, agences} = props;
    const [showPassword, setShowPassword] = useState(false)
console.log(villes)
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const getSelectableRoles = () => {
        return isAdmin() ? [Role.ROLE_EXPLOITANT, Role.ROLE_CLIENT, Role.ROLE_OPERATEUR] : [Role.ROLE_CLIENT, Role.ROLE_OPERATEUR];
    }

    const isRoleSelected = (role) => {
        return Array.isArray(values.roles) && values.roles.includes(role);
    }

    const getClassnameForSelectedRole = (role) => {
        if (role === Role.ROLE_EXPLOITANT) {
            return "toggle-button button-selected-primary";
        } else if (role === Role.ROLE_OPERATEUR) {
            return "toggle-button button-selected-secondary";
        } else if (role === Role.ROLE_CLIENT) {
            return "toggle-button button-selected-orange";
        }
    }

    const shouldAttachExploitant = (role) => {
        return role.includes(Role.ROLE_CLIENT) || role.includes(Role.ROLE_OPERATEUR);
    }

    const isClient = (role) => {
        return role.includes(Role.ROLE_CLIENT)
    }

    const isOperateur = (role) => {
        return role.includes(Role.ROLE_OPERATEUR)
    }

    return (
        <Grid container spacing={1} className={"sectionContainer"}>
            <Grid size={6}>
                <Grid container>
                    <Grid size={12}>
                        <Typography variant={"h5"} className={"sectionHeader"}>Role</Typography>
                    </Grid>

                    {/*ROLE FIELD*/}
                    <Grid size={12} container alignItems={"center"}>
                        <Grid size={3}>
                            Choix du rôle <span className="asterix">*</span>
                        </Grid>
                        <Grid size={9}>
                            <Field
                                type="text"
                                name="roles"
                                value={values.roles}>
                                {({field, form}) => (
                                    <ToggleButtonGroup
                                        color={"primary"}
                                        exclusive
                                        size={"medium"}
                                        name="roles"
                                        value={values.roles}
                                        onChange={(event, newValue) => {
                                            form.setFieldValue('roles', [newValue]);
                                            if (newValue === Role.ROLE_CLIENT) {
                                                const st = form.values.serviceTypes;
                                                if (!Array.isArray(st) || st.length === 0) {
                                                    form.setFieldValue('serviceTypes', ['lavage']);
                                                }
                                            }
                                        }}
                                        aria-label={"Accreditation"}
                                    >
                                        {getSelectableRoles() && getSelectableRoles().map(r => {
                                                return (
                                                    <ToggleButton key={r} value={r} disabled={mode === "edit"}
                                                                  className={isRoleSelected(r) ? getClassnameForSelectedRole(r) : "toggle-button"}>{getRole([r])}</ToggleButton>
                                                )
                                            }
                                        )}
                                    </ToggleButtonGroup>
                                )}
                            </Field>
                        </Grid>
                    </Grid>

                    {/*EXPLOITANT FIELD*/}
                    {shouldAttachExploitant(values.roles) &&
                        <Grid size={12} container alignItems={"center"} className={"mt-2"}>
                            <Grid size={3}>
                                Exploitant à rattacher <span className="asterix">*</span>
                            </Grid>
                            <Grid size={9}>
                                <Field
                                    type="text"
                                    name="exploitant"
                                    value={values.exploitant}>
                                    {({field, form}) => (
                                        <FormControl fullWidth error={Boolean(errors.exploitant)}>
                                            <InputLabel id="label-exploitant">Sélectionner l'exploitant :</InputLabel>
                                            <Select
                                                labelId="label-exploitant"
                                                label="Sélectionner l'exploitant :"
                                                variant="outlined"
                                                name="exploitant"
                                                value={values.exploitant}
                                                onChange={handleChange}
                                            >
                                                {exploitants && exploitants.map((e) => {
                                                    return (
                                                        <MenuItem key={e.id} value={e["@id"]}>
                                                            {e.libelle}
                                                        </MenuItem>
                                                    )
                                                })}
                                            </Select>
                                            {form.errors.exploitant &&
                                                form.touched.exploitant &&
                                                String(form.errors.exploitant) &&
                                                <FormHelperText error={true}>{form.errors.exploitant}</FormHelperText>}
                                        </FormControl>
                                    )
                                    }
                                </Field>
                            </Grid>
                        </Grid>
                    }

                    {/*EMAIL NOTIFICATION FIELD*/}
                    {isClient(values.roles) &&
                        <>
                            <Grid size={12} container alignItems={"center"} className={"mt-1 pt-1"}>
                                <Grid size={5}>
                                    Notifier si lavage impossible ?
                                </Grid>
                                <Grid size={7}>
                                    <Field
                                        type="text"
                                        value={values.emailNotificationsLavageImpossible ? values.emailNotificationsLavageImpossible : false}>
                                        {({field, form}) => (
                                            <ToggleButtonGroup
                                                color={"primary"}
                                                exclusive
                                                size={"medium"}
                                                name="emailNotificationsLavageImpossible"
                                                value={values.emailNotificationsLavageImpossible}
                                                onChange={(event, newValue) => {
                                                    if (newValue !== null) form.setFieldValue('emailNotificationsLavageImpossible', newValue);
                                                }}
                                                aria-label={"Notifier lavage impossible"}
                                            >
                                                <ToggleButton value={false}
                                                              className={values.emailNotificationsLavageImpossible === false ? "toggle-button button-selected-red" : "toggle-button"}>Non</ToggleButton>
                                                <ToggleButton value={true}
                                                              className={values.emailNotificationsLavageImpossible === true ? "toggle-button button-selected-green" : "toggle-button"}>Oui</ToggleButton>
                                            </ToggleButtonGroup>

                                        )}
                                    </Field>

                                </Grid>
                            </Grid>

                            <Grid size={12} container alignItems={"center"} className={"mt-1 pt-1"}>
                                <Grid size={5}>
                                    Notifier si maintenance nécessaire ?
                                </Grid>
                                <Grid size={7}>
                                    <Field
                                        type="text"
                                        value={values.emailNotificationsMaintenance ? values.emailNotificationsMaintenance : false}>
                                        {({field, form}) => (
                                            <ToggleButtonGroup
                                                color={"primary"}
                                                exclusive
                                                size={"medium"}
                                                name="emailNotificationsMaintenance"
                                                value={values.emailNotificationsMaintenance}
                                                onChange={(event, newValue) => {
                                                    if (newValue !== null) form.setFieldValue('emailNotificationsMaintenance', newValue);
                                                }}
                                                aria-label={"Notifier lavage maintenance"}
                                            >
                                                <ToggleButton value={false}
                                                              className={values.emailNotificationsMaintenance === false ? "toggle-button button-selected-red" : "toggle-button"}>Non</ToggleButton>
                                                <ToggleButton value={true}
                                                              className={values.emailNotificationsMaintenance === true ? "toggle-button button-selected-green" : "toggle-button"}>Oui</ToggleButton>
                                            </ToggleButtonGroup>

                                        )}
                                    </Field>

                                </Grid>
                            </Grid>

                            <Grid size={12} container alignItems={"center"} className={"mt-1 pt-1"}>
                                <Grid size={5}>
                                    Notifier si lavage réussi ?
                                </Grid>
                                <Grid size={7}>
                                    <Field
                                        type="text"
                                        value={values.emailNotificationsLavageDone ? values.emailNotificationsLavageDone : false}>
                                        {({field, form}) => (
                                            <ToggleButtonGroup
                                                color={"primary"}
                                                exclusive
                                                size={"medium"}
                                                name="emailNotificationsLavageDone"
                                                value={values.emailNotificationsLavageDone}
                                                onChange={(event, newValue) => {
                                                    if (newValue !== null) form.setFieldValue('emailNotificationsLavageDone', newValue);
                                                }}
                                                aria-label={"Notifier lavage reussi"}
                                            >
                                                <ToggleButton value={false}
                                                              className={values.emailNotificationsLavageDone === false ? "toggle-button button-selected-red" : "toggle-button"}>Non</ToggleButton>
                                                <ToggleButton value={true}
                                                              className={values.emailNotificationsLavageDone === true ? "toggle-button button-selected-green" : "toggle-button"}>Oui</ToggleButton>
                                            </ToggleButtonGroup>

                                        )}
                                    </Field>

                                </Grid>
                            </Grid>
                        </>
                    }

                    {/* SERVICE TYPES FIELD (Client) */}
                    {isClient(values.roles) && (
                        <Grid size={12} container alignItems={"center"} className={"mt-1 pt-1"}>
                            <Grid size={5}>
                                Type de service <span className="asterix">*</span>
                            </Grid>
                            <Grid size={7}>
                                <Field type="text" name="serviceTypes" value={values.serviceTypes || []}>
                                    {({ field, form }) => (
                                        <FormControl fullWidth error={Boolean(form.errors.serviceTypes)}>
                                            <ToggleButtonGroup
                                                color={"primary"}
                                                size={"medium"}
                                                name="serviceTypes"
                                                value={values.serviceTypes || []}
                                                onChange={(event, newValue) => {
                                                    // newValue is an array when exclusive is false
                                                    form.setFieldValue('serviceTypes', newValue ?? []);
                                                }}
                                                aria-label={"Type de service"}
                                                exclusive={false}
                                            >
                                                <ToggleButton value={'lavage'}
                                                              className={(values.serviceTypes || []).includes('lavage') ? "toggle-button button-selected-green" : "toggle-button"}>Lavage</ToggleButton>
                                                <ToggleButton value={'graffiti'}
                                                              className={(values.serviceTypes || []).includes('graffiti') ? "toggle-button button-selected-orange" : "toggle-button"}>Graffiti</ToggleButton>
                                            </ToggleButtonGroup>
                                            {form.errors.serviceTypes && (
                                                <FormHelperText error={true}>{String(form.errors.serviceTypes)}</FormHelperText>
                                            )}
                                        </FormControl>
                                    )}
                                </Field>
                            </Grid>
                        </Grid>
                    )}

                    {/* VILLE FIELD (Client Graffiti) */}
                    {isClient(values.roles) && (values.serviceTypes || []).includes('graffiti') &&  (
                        <Grid size={12} container alignItems={"center"} className={"mt-1 pt-1"}>
                            <Grid size={3}>
                                Ville <span className="asterix">*</span>
                            </Grid>
                            <Grid size={9}>
                                <Field type="text" name="ville" value={values.ville || ''}>
                                    {({ field, form }) => (
                                        <FormControl fullWidth size="small" error={Boolean(form.errors.ville && form.touched.ville)}>
                                            <InputLabel id="label-ville">Sélectionner la ville</InputLabel>
                                            <Select
                                                labelId="label-ville"
                                                name="ville"
                                                label="Sélectionner la ville"
                                                value={values.ville || ''}
                                                onChange={(e) => form.setFieldValue('ville', e.target.value)}
                                            >
                                                <MenuItem value=""><em>Aucune</em></MenuItem>
                                                {villes.map((v) => (
                                                    <MenuItem key={v['@id'] || v.id} value={v['@id'] || v['@id']}>
                                                        {v.nom || v.libelle || v.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {form.errors.ville && form.touched.ville && (
                                                <FormHelperText error={true}>{String(form.errors.ville)}</FormHelperText>
                                            )}
                                        </FormControl>
                                    )}
                                </Field>
                            </Grid>
                        </Grid>
                    )
								}
                    {/* LIBELLE FACTURATION (Client) */}
                    {isClient(values.roles) && (
                      <Grid size={12} container alignItems={"center"} className={"mt-1 pt-1"}>
                          <Grid size={3}>
                              Libellé facturation
                          </Grid>
                          <Grid size={9}>
                              <Field type="text" name="libelleFacturation">
                                  {({field, form}) => (
                                    <TextField
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.libelleFacturation ?? ''}
                                      variant="outlined"
                                      margin="normal"
                                      size="small"
                                      fullWidth
                                      name="libelleFacturation"
                                      label="Libellé facturation"
                                    />
                                  )}
                              </Field>
                          </Grid>
                      </Grid>
                    )}

                    {/* AGENCE (Client) */}
                    {isClient(values.roles) && (
                      <Grid size={12} container alignItems={"center"} className={"mt-1 pt-1"}>
                          <Grid size={3}>
                              Agence
                          </Grid>
                          <Grid size={9}>
                              <Field name="agence">
                                  {({field, form}) => (
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="label-agence">Sélectionner une agence</InputLabel>
                                        <Select
                                          labelId="label-agence"
                                          label="Sélectionner une agence"
                                          value={values.agence ?? ''}
                                          onChange={(e) => form.setFieldValue('agence', e.target.value)}
                                        >
                                            <MenuItem value=""><em>Aucune</em></MenuItem>
                                            {(agences || []).map((a) => (
                                              <MenuItem key={a.id} value={`/api/agences/${a.id}`}>
                                                  {a.libelle}
                                              </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                  )}
                              </Field>
                          </Grid>
                      </Grid>
                    )}

                    <Grid size={12} className={"mt-2"}>
                        <Typography variant={"h5"} className={"sectionHeader"}>Informations</Typography>
                    </Grid>

                    {/*LIBELLE FIELD*/}
                    <Grid size={12} container alignItems={"center"}>
                        <Grid size={3}>
                            Libellé
                        </Grid>
                        <Grid size={9}>
                            <Field
                                type="text"
                                value={values.libelle}>
                                {({field, form}) => (
                                    <TextField
                                        error={
                                            Boolean(form.errors.libelle && form.touched.libelle)
                                        }
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.libelle}
                                        variant="outlined"
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        name="libelle"
                                        label="Libellé"
                                        autoFocus
                                        helperText={
                                            form.errors.libelle &&
                                            form.touched.libelle &&
                                            String(form.errors.libelle)
                                        }/>
                                )}
                            </Field>
                        </Grid>
                    </Grid>

                    {/*MAIL FIELD*/}
                    <Grid size={12} container alignItems={"center"}>
                        <Grid size={3}>
                            Adresse email <span className="asterix">*</span>
                        </Grid>
                        <Grid size={9}>
                            <Field
                                type="text"
                                value={values.email ? values.email : ''}>
                                {({field, form}) => (
                                    <TextField
                                        error={
                                            Boolean(form.errors.email && form.touched.email)
                                        }
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                        variant="outlined"
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        name="email"
                                        label="Adresse email"
                                        helperText={
                                            form.errors.email &&
                                            form.touched.email &&
                                            String(form.errors.email)
                                        }/>
                                )}
                            </Field>
                        </Grid>
                    </Grid>

                    {/*PASSWORD FIELD*/}
                    <Grid size={12} container alignItems={"center"}>
                        <Grid size={3}>
                            Mot de passe {mode === "create" && <span className="asterix">*</span>}
                        </Grid>
                        <Grid size={9}>
                            <Field
                                type="text"
                                value={values.password ? values.password : ''}>
                                {({field, form}) => (
                                    <TextField
                                        error={
                                            Boolean(form.errors.password && form.touched.password)
                                        }
                                        type={showPassword ? "text" : "password"}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.password}
                                        variant="outlined"
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        name="password"
                                        label="Mot de passe"
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                    >
                                                        {showPassword ? <VisibilityOff/> : <Visibility/>}
                                                    </IconButton>
                                                </InputAdornment>
                                        }}
                                        helperText={
                                            form.errors.password &&
                                            form.touched.password &&
                                            String(form.errors.password)
                                        }/>
                                )}
                            </Field>
                        </Grid>
                    </Grid>

                    {/*RFID FIELD*/}
                    <Grid size={12} container alignItems={"center"}>
                        <Grid size={3}>
                            Données RFID
                        </Grid>
                        <Grid size={9}>
                            <Field
                                type="text"
                                value={values.rfid}>
                                {({field, form}) => (
                                    <TextField
                                        error={
                                            Boolean(form.errors.rfid && form.touched.rfid)
                                        }
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.rfid ? values.rfid : ''}
                                        variant="outlined"
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        name="rfid"
                                        label="Données RFID"
                                        helperText={
                                            form.errors.rfid &&
                                            form.touched.rfid &&
                                            String(form.errors.rfid)
                                        }/>
                                )}
                            </Field>
                        </Grid>
                    </Grid>

                    {/*ACCREDITED FIELD*/}
                    <Grid size={12} container alignItems={"center"} className={"mt-1 pt-1"}>
                        <Grid size={3}>
                            Accréditer l'utilisateur ?
                        </Grid>
                        <Grid size={9}>
                            <Field
                                type="text"
                                value={values.isAccredited ? values.isAccredited : false}>
                                {({field, form}) => (
                                    <ToggleButtonGroup
                                        color={"primary"}
                                        exclusive
                                        size={"medium"}
                                        name="isAccredited"
                                        value={values.isAccredited}
                                        onChange={(event, newValue) => {
                                            if (newValue !== null) form.setFieldValue('isAccredited', newValue);
                                        }}
                                        aria-label={"Accreditation"}
                                    >
                                        <ToggleButton value={false}
                                                      className={values.isAccredited === false ? "toggle-button button-selected-red" : "toggle-button"}>Non</ToggleButton>
                                        <ToggleButton value={true}
                                                      className={values.isAccredited === true ? "toggle-button button-selected-green" : "toggle-button"}>Oui</ToggleButton>
                                    </ToggleButtonGroup>

                                )}
                            </Field>
                        </Grid>
                    </Grid>

                    {/* RH FEATURE ENABLED FIELD*/}
                    {isOperateur(values.roles) &&
                        <Grid size={12} container alignItems={"center"} className={"mt-1 pt-1"}>
                            <Grid size={3}>
                                Activer la gestion des heures ?
                            </Grid>
                            <Grid size={9}>
                                <Field
                                    type="text"
                                    value={values.RHFeatureEnabled ? values.RHFeatureEnabled : false}>
                                    {({field, form}) => (
                                        <ToggleButtonGroup
                                            color={"primary"}
                                            exclusive
                                            size={"medium"}
                                            name="RHFeatureEnabled"
                                            value={values.RHFeatureEnabled}
                                            onChange={(event, newValue) => {
                                                if (newValue !== null) form.setFieldValue('RHFeatureEnabled', newValue);
                                            }}
                                            aria-label={"RHFeatureEnabled"}
                                        >
                                            <ToggleButton value={false}
                                                          className={values.RHFeatureEnabled === false ? "toggle-button button-selected-red" : "toggle-button"}>Non</ToggleButton>
                                            <ToggleButton value={true}
                                                          className={values.RHFeatureEnabled === true ? "toggle-button button-selected-green" : "toggle-button"}>Oui</ToggleButton>
                                        </ToggleButtonGroup>

                                    )}
                                </Field>

                            </Grid>
                        </Grid>
                    }


                </Grid>
            </Grid>
            <Grid size={1}>
                {/*SEPARATOR*/}
            </Grid>
            <Grid size={5}>
                <Grid size={12}>
                    <Typography variant={"h5"} className={"sectionHeader"}>Logo</Typography>
                </Grid>

                {/*LOGO FIELD*/}
                <Grid size={12} container alignItems={"center"}>
                    <Grid size={12}>
                        <Field name="logo">
                            {({form}) => (
                                <FormControl fullWidth variant="outlined">
                                    <Grid container>
                                        <input
                                            id="logo-input"
                                            type="file"
                                            accept="image/*"
                                            style={{display: 'none'}}
                                            onChange={(event) => {
                                                handleLogoChanged(event, form)
                                            }}
                                        />
                                        <label htmlFor="logo-input">
                                            <Button variant="contained" component="span">
                                                Charger un logo
                                            </Button>
                                        </label>
                                    </Grid>
                                    {form.errors.logo && form.touched.logo && (
                                        <FormHelperText error={true}>{form.errors.logo}</FormHelperText>
                                    )}
                                </FormControl>
                            )}
                        </Field>
                    </Grid>
                    <Grid size={9} className={"mt-2"}>
                        {values.logoUrl && (
                            <img src={Constants.API_ASSETS_USER_LOGO + values.logoUrl} className={"logo-preview"}
                                 alt={"Logo utilisateur"}/>
                        )}

                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default UserDataField;
